export const etpRoles = {
  secretaria: 'secretaria',
  empresa: 'empresa',
  secretariaUsuarios: 'secretaria_usuarios'
}
